/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Limits_BodyInputs */

const en_svc_agents_limits_body = /** @type {(inputs: Svc_Agents_Limits_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autonomy is a setting, not a selling point. You decide how much of it each agent has.`)
};

const lv_svc_agents_limits_body = /** @type {(inputs: Svc_Agents_Limits_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autonomija ir iestatījums, nevis reklāmas solījums. Jūs nosakāt, cik daudz tās ir katram aģentam.`)
};

/**
* | output |
* | --- |
* | "Autonomy is a setting, not a selling point. You decide how much of it each agent has." |
*
* @param {Svc_Agents_Limits_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_limits_body = /** @type {((inputs?: Svc_Agents_Limits_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Limits_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_limits_body(inputs)
	return en_svc_agents_limits_body(inputs)
});